import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';

import Swal from "sweetalert2";
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { SessionManagementService } from 'projects/fe-common-v2/src/lib/services/session-management.service';
import { HelperService } from './helper.service';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class HttpService {
    config: string = environment.baseURL;

    constructor(private sessionManagementService: SessionManagementService, private router: Router,
        private _http: HttpClient, private translate: TranslateService) {

    }

    resolveApiUrl(endpoint: string) {
        let apiUrl = this.config + endpoint;
        //console.log('ApiService.resolveApiUrl: ', apiUrl);
        return apiUrl;
    }



    getRetryCount() {
        return 0;
    }

    // tslint:disable-next-line:no-shadowed-variable
    get<T>(endpoint: string, options?: {}): Observable<T> {
        return this._http.get<T>(this.resolveApiUrl(endpoint), options).pipe(retry(this.getRetryCount()), tap(
            (data) => {
                return data;
            },
            (error: HttpErrorResponse) => {
                return this.handleError(error);
            }
        ));
    }

    post<T>(endpoint: string, body: any, options?: {}): Observable<T> {
        return this._http.post<T>(this.resolveApiUrl(endpoint), body, options).pipe(retry(this.getRetryCount()), tap(
            (data) => {
                return data;
            },
            (error: HttpErrorResponse) => {
                return this.handleError(error);
            }
        ));
    }

    put<T>(endpoint: string, body: any): Observable<T> {
        return this._http.put<T>(this.resolveApiUrl(endpoint), body).pipe(retry(this.getRetryCount()), tap(
            (data) => {
                return data;
            },
            (error: HttpErrorResponse) => {
                return this.handleError(error);
            }
        ));
    }

    delete<T>(endpoint: string): Observable<T> {
        return this._http.delete<T>(this.resolveApiUrl(endpoint)).pipe(retry(this.getRetryCount()), tap(
            (data) => {
                return data;
            },
            (error: HttpErrorResponse) => {
                return this.handleError(error);
            }
        ));
    }

    deleteWithPayload<T>(endpoint: string, payload?: any): Observable<T> {
        const options: any = {};

        if (payload) {
            options.body = payload;
        }

        return this._http.delete<T>(this.resolveApiUrl(endpoint), options).pipe(
            retry(this.getRetryCount()),
            catchError((error: HttpErrorResponse) => this.handleError(error))
        );
    }

    request(req: HttpRequest<any>): any {
        this._http.request(req).pipe(retry(this.getRetryCount()), tap(
            (data) => {
                return data;
            },
            (error: HttpErrorResponse) => {
                return this.handleError(error);
            }
        ));
    }



    private handleError(error: HttpErrorResponse) {
        Swal.fire(this.translate.instant('Swal_Message.Sorry'), this.translate.instant(error?.error?.reason || error?.error?.message), 'error').then();
        // session expired
        if (error.status == 401) {
            console.log('error.status', error.status)
            this.sessionManagementService.fireSessionExpired();
            HelperService.onLogOut();
            // this.router.navigate(['/']);
        } else {
            console.error("Something went wrong. Please try again later");
        }

        return of(null);
    }
}


